module.exports = __webpack_public_path__ + "assets/map_plus.bbc50c92.svg";